import { ResolverProps } from '../resolverHelpers';
import { TenantConfig } from '@jd/client/tenant/getSiteConfig';

export type SectionContextProps = {
  index: number;
  section: ResolverProps['section'];
  config: TenantConfig;
};

export type SectionContext = {
  index: number;
  isEven: boolean;
  attrData: {
    id: string;
    type: string;
  };
  config: TenantConfig;
};

const getSectionContext = ({
  index,
  section,
  config,
}: SectionContextProps): SectionContext => {
  return {
    index,
    attrData: {
      id: section.id || `${index}`,
      type: section.blockType,
    },
    isEven: !(index % 2),
    config,
  };
};
export default getSectionContext;
